export const data = [
  { label: 'Home', path: '/', id: 'home' },
  { label: 'About', path: '/about', id: 'about' },
  { label: 'Skills', path: '/skills', id: 'skills' },
  { label: 'Projects', path: '/projects', id: 'portfolio' },
  { label: 'Testimonial', path: '/testimonial', id: 'testimonial' },
  { label: 'Contact', path: '/contact', id: 'contact' },
]
